import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "./commonSlice";
import themeSettingSlice from "./themeSettingSlice";
import authReducer from "./authSlice"; 
import contactReducer from "./contactSlice";
import reduxReLeadsReducer from "./leadSlice";

const store = configureStore({
  reducer: {
    common: commonSlice,
    themeSetting: themeSettingSlice,
    auth: authReducer,
    contacts: contactReducer, 
    reduxReLeads: reduxReLeadsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
